import { React } from 'react';
import PropTypes from 'prop-types';
import './clickbox.scss';

// Icons
// ---------------------
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron_left_black_24dp.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/file_download_24dp.svg';

export const Clickbox = ({
  text,
  path,
  aria,
  isExpanded = false,
  isDownload = false,
  newTab = false,
  onClick,
  className,
  ...props
}) => {
  const setAriaLabel = () => {
    if (isDownload) {
      return aria ? aria : `Download ${text}`;
    }
    return aria ? aria : `Go to ${text}`;
  };
  const setTarget = () => {
    return newTab ? '_blank' : '';
  };
  const setRel = () => {
    return newTab ? 'noopener noreferrer' : '';
  };

  const inner = (
    <>
      {' '}
      <span>{text}</span>
      {isDownload ? (
        <DownloadIcon className="download" />
      ) : (
        <ChevronIcon className="chevron" />
      )}
    </>
  );
  const clickboxElement = path ? (
    <a
      className={`clickbox`}
      href={path}
      aria-label={setAriaLabel()}
      aria-expanded={isExpanded}
      target={setTarget()}
      rel={setRel()}
      onClick={onClick}
      data-testid="clickbox"
      tabIndex={0}
    >
      {inner}
    </a>
  ) : (
    <button
      className={`stripped-button clickbox`}
      aria-label={setAriaLabel()}
      aria-expanded={isExpanded}
      onClick={onClick}
      data-testid="clickbox"
      tabIndex={0}
    >
      {inner}
    </button>
  );

  return (
    <div className={`clickbox-component${className ? ` ${className}` : ''}`}>
      {clickboxElement}
    </div>
  );
};

Clickbox.propTypes = {
  text: PropTypes.string,
  path: PropTypes.string,
  aria: PropTypes.string,
};
